import { config } from '../../../config';

export class CookieUtils {
  private constructor() {}

  public static getApiCookiesUrl(): string | undefined {
    const baseUrl = config.get('ApiBaseUrl');
    const result = /^(https?:\/\/[^/:]*)/.exec(baseUrl);
    return result?.[1];
  }
}
